<div id="messageBox" class="message-box-container">
  <div fxLayout="row" fxLayoutAlign="center center">
    <mat-icon class="icon" [svgIcon]="getIconKey(settings.icon)"></mat-icon>
  </div>
  <mat-dialog-content class="content main-content">
    <div>{{ settings.message }}</div>
    <div id="htmlCode"></div>
  </mat-dialog-content>
  <mat-dialog-actions class="button-container" fxLayoutAlign="center">
    @if (settings.button === MessageBoxButtons.OK) {
      <div>
        <button class="buttonMessageBox" (click)="onClick(DialogResult.OK)" mat-button mat-dialog-close>
          {{ settings.okButtonText || res('Ok') }}
        </button>
      </div>
    }

    @if (settings.button === MessageBoxButtons.OKCancel) {
      <div fxLayoutAlign="center">
        <button fxFlex.sm="38" class="buttonMessageBox" (click)="onClick(DialogResult.OK)" mat-button mat-dialog-close>
          {{ settings.okButtonText || res('Ok') }}
        </button>
        <button
          fxFlex.sm="38"
          class="buttonMessageBox"
          (click)="onClick(DialogResult.Cancel)"
          mat-button
          mat-dialog-close
          >
          {{ settings.cancelButtonText || res('Cancel') }}
        </button>
      </div>
    }

    @if (settings.button === MessageBoxButtons.AbortRetryIgnore) {
      <div>
        <button class="buttonMessageBox" (click)="onClick(DialogResult.Abort)" mat-button mat-dialog-close>
          {{ res('Abort') }}
        </button>
        <button class="buttonMessageBox" (click)="onClick(DialogResult.Retry)" mat-button mat-dialog-close>
          {{ res('Retry') }}
        </button>
        <button class="buttonMessageBox" (click)="onClick(DialogResult.Ignore)" mat-button mat-dialog-close>
          {{ res('Ignore') }}
        </button>
      </div>
    }

    @if (settings.button === MessageBoxButtons.YesNoCancel) {
      <div>
        <button class="buttonMessageBox" (click)="onClick(DialogResult.Yes)" mat-button mat-dialog-close>
          {{ res('Yes') }}
        </button>
        <button class="buttonMessageBox" (click)="onClick(DialogResult.No)" mat-button mat-dialog-close>
          {{ res('No') }}
        </button>
        <button class="buttonMessageBox" (click)="onClick(DialogResult.Cancel)" mat-button mat-dialog-close>
          {{ res('Cancel') }}
        </button>
      </div>
    }

    @if (settings.button === MessageBoxButtons.YesIgnoreCancel) {
      <div>
        <button class="buttonMessageBox" (click)="onClick(DialogResult.Yes)" mat-button mat-dialog-close>
          {{ res('Yes') }}
        </button>
        <button class="buttonMessageBox" (click)="onClick(DialogResult.Ignore)" mat-button mat-dialog-close>
          {{ res('Ignore') }}
        </button>
        <button class="buttonMessageBox" (click)="onClick(DialogResult.Cancel)" mat-button mat-dialog-close>
          {{ res('Cancel') }}
        </button>
      </div>
    }

    @if (settings.button === MessageBoxButtons.YesNo) {
      <div>
        <button class="buttonMessageBox" (click)="onClick(DialogResult.Yes)" mat-button mat-dialog-close>
          {{ res('Yes') }}
        </button>
        <button class="buttonMessageBox" (click)="onClick(DialogResult.No)" mat-button mat-dialog-close>
          {{ res('No') }}
        </button>
      </div>
    }

    @if (settings.button === MessageBoxButtons.RetryCancel) {
      <div>
        <button class="buttonMessageBox" (click)="onClick(DialogResult.Retry)" mat-button mat-dialog-close>
          {{ res('Retry') }}
        </button>
        <button class="buttonMessageBox" (click)="onClick(DialogResult.Cancel)" mat-button mat-dialog-close>
          {{ res('Cancel') }}
        </button>
      </div>
    }
  </mat-dialog-actions>
  @if (settings.errorMessage) {
    <div class="error-content">
      <mat-divider id="dividerMsgBox"></mat-divider>
      <mat-expansion-panel>
        <mat-expansion-panel-header class="header" [collapsedHeight]="'auto'" [expandedHeight]="'auto'">
          <mat-panel-title class="error-title">{{ errorMessageCaption }}</mat-panel-title>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <pre id="error-message" #copyToClipboard>{{ settings.errorMessage }}</pre>
          <button mat-button class="copieren" (click)="toClipboard(settings.errorMessage)" mat-button>
            {{ res('Copy_Message') }}...
          </button>
        </ng-template>
      </mat-expansion-panel>
    </div>
  }
</div>
